import React from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

interface PlaygroundUnsavedChangesModalProps {
  isOpen: boolean;
  workflowName: string;
  onSaveAndSwitch: () => void;
  onDiscardAndSwitch: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

const PlaygroundUnsavedChangesModal: React.FC<PlaygroundUnsavedChangesModalProps> = ({
  isOpen,
  workflowName,
  onSaveAndSwitch,
  onDiscardAndSwitch,
  onCancel,
  isSaving = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <ModalContent>
        <ModalHeader className="flex items-center gap-2">
          <Icon className="w-5 h-5 text-warning" icon="solar:danger-triangle-linear" />
          {t("Unsaved Changes")}
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-default-600">
            {t('You have unsaved changes to "{{name}}". What would you like to do?', {
              name: workflowName || t("New Workflow"),
            })}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="flat" onPress={onCancel}>
            {t("Cancel")}
          </Button>
          <Button color="danger" size="sm" variant="flat" onPress={onDiscardAndSwitch}>
            {t("Discard")}
          </Button>
          <Button color="primary" isLoading={isSaving} size="sm" onPress={onSaveAndSwitch}>
            {t("Save & Continue")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PlaygroundUnsavedChangesModal;
